module.exports = __webpack_public_path__ + "assets/icons/flag.svg?3988ee";


//////////////////
// WEBPACK FOOTER
// ../xod-client/src/core/assets/icons/flag.svg
// module id = 998
// module chunks = 0